import Grid from '$components/layout/Grid';
import Player from '../util/Player';
import Styled from './styled';

const { Row, Col } = Grid;

export default function FewestMinutesImages() {
  return (
    <Styled className="FewestMinutesImages">
      <h2>
        The five players who{' '}
        <span>
          play the fewest
          <br className="xs-none" /> minutes to pay off their car
        </span>
      </h2>
      <Row>
        <Col xs={0} md={1} />
        <Player
          number={1}
          name="N'Golo Kante"
          minute="10 minutes, 15 seconds"
          team="Chelsea"
          car="Mini Cooper S"
          value="23,395"
        />
        <Player
          number={2}
          name="Tanguy Ndombele"
          minute="16 minutes, 9 seconds"
          team="Tottenham Hotspur"
          car="Volkswagen Touareg"
          value="49,135"
        />
        <Player
          number={3}
          name="David De Gea"
          minute="21 minutes, 12 seconds"
          team="Manchester United"
          car="Aston Martin Vantage"
          value="120,900"
        />
        <Player
          number={4}
          name="Angelo Ogbonna"
          minute="21 minutes, 56 seconds"
          team="West Ham"
          car="Fiat Freemont"
          value="23,342"
        />
        <Player
          number={5}
          name="Joao Moutinho"
          minute="24 minutes, 13 seconds"
          team="Wolverhampton Wanderers"
          car="Jaguar F-Pace"
          value="36,820"
        />
      </Row>
    </Styled>
  );
}
